import React, { useContext } from 'react';
import { Layout, Row, Col, Typography } from 'antd';

import { AppContext } from 'context/AppContext';
import HeaderMain from './HeaderMain';
import ProjectDropdown from 'components/content/homeView/components/ProjectDropdown';
const { Title } = Typography;
const { Header } = Layout;

const HeaderProject = (props) => {
    let appContext = useContext(AppContext);

    const handleRefreshProject = () => {
        props.setRerenderProjectData(!props.rerenderProjectData);
    };

    return (
        <>
            <Header className="site-layout-background" style={{ padding: 0 }}>
                <HeaderMain />

                <Row
                    className="header-box-shadow"
                    justify="space-between"
                    align="middle"
                    style={{
                        position:
                            appContext.currentLocation == '2' ? '' : 'sticky',
                        marginBottom:
                            appContext.analysisTableChartDisplay !== 'table' &&
                            appContext.currentLocation == '2'
                                ? 4
                                : 0
                    }}
                >
                    <Col>
                        <Title
                            style={{ marginLeft: 20, paddingTop: 10 }}
                            level={4}
                        >
                            {props.projectData.name}
                        </Title>
                    </Col>
                    <Col
                        style={{ paddingRight: 7 }}
                        className="dropdown dropdown-header"
                    >
                        <ProjectDropdown
                            location="project"
                            row={props.projectData}
                            hideDelete={true}
                            handleRefreshProject={handleRefreshProject}
                            hideExportAnalysis={false}
                            setGetSvg={props.setGetSvg}
                        />
                    </Col>
                </Row>
            </Header>
        </>
    );
};

export default HeaderProject;
